import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { ColumnTreeView } from './ColumnTreeView';

interface ColumnVisibilityManagerProps {
  columns: GridColDef[];
  columnVisibility: { [key: string]: boolean };
  onColumnVisibilityChange: (newModel: { [key: string]: boolean }) => void;
}

/**
 * ColumnVisibilityManager - A standalone component for managing column visibility
 * 
 * This component wraps the ColumnTreeView and can be placed anywhere in the UI
 * (toolbar, separate panel, etc.). It manages no internal state - all state is
 * controlled by the parent component.
 */
export const ColumnVisibilityManager: React.FC<ColumnVisibilityManagerProps> = React.memo(({
  columns,
  columnVisibility,
  onColumnVisibilityChange,
}) => {
  return (
    <ColumnTreeView
      columns={columns}
      columnVisibility={columnVisibility}
      onColumnVisibilityChange={onColumnVisibilityChange}
    />
  );
}, (prevProps, nextProps) => {
  // Custom comparison: skip render if columns and visibility are identical
  // Include callback comparison to ensure proper updates when needed
  return (
    prevProps.columns === nextProps.columns &&
    prevProps.columnVisibility === nextProps.columnVisibility &&
    prevProps.onColumnVisibilityChange === nextProps.onColumnVisibilityChange
  );
});

